import { Autocomplete, TextField, createFilterOptions } from "@mui/material"
import LoadingSpinner from "components/LoadingSpinner";
import NotificationProvider from "components/NotificationProvider";
import { useAddServiceProviderMutation, useGetServiceProvidersQuery } from "features/serviceProvider/serviceProviderSlice"
import { PricingListStyle } from "./style";
import { arrayToObject } from "utils/object-util";

export const ServiceProviderField = ({ value, onChange, required, label, multiple }) => {
    const classes = PricingListStyle()

    const filter = createFilterOptions();
    let { data: serviceProviders, error: serviceProvidersError, isLoading: isLoadingServiceProviders } = useGetServiceProvidersQuery();
    const [addServiceProvider, { isLoading: isAdding }] = useAddServiceProviderMutation();

    let sProvidersByName = arrayToObject(serviceProviders, 'name');

    let serviceProvider = serviceProviders?.find(s => s.id === value);

    const onValueChange = async (newValue) => {
        if (!multiple ? 
            ((newValue && newValue.inputValue) || typeof newValue === 'string') :
                ((!!newValue[newValue.length - 1].inputValue || typeof newValue[newValue.length-1] === 'string') && !sProvidersByName[newValue[newValue.length - 1].inputValue]))  {
            // Create a new value from the user input
            let result = await addServiceProvider({ name: multiple ? newValue[newValue.length-1].inputValue : newValue.inputValue });
            if (result && !result.error) {
                NotificationProvider.success("Service Provider added successfully");
            } else {
                NotificationProvider.error("Something happened, try again or contact support");
            }
            onChange(multiple ? newValue.map(v => v.id).concat(result?.data).filter(c => c !== undefined) : result?.data);
        } else {
            multiple ? onChange(newValue.map(v => v.id)) :
                onChange(newValue?.id);
        }
    }

    return <>
        <LoadingSpinner loading={isAdding || isLoadingServiceProviders} />
        <Autocomplete
            multiple={multiple}
            value={serviceProvider}
            onChange={(event, newValue) => {onValueChange(newValue)}}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const { inputValue } = params;
                // Suggest the creation of a new value
                const isExisting = options.some((option) => inputValue === option.name);
                if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        inputValue,
                        name: `Add "${inputValue}"`,
                    });
                }
                return filtered;
            }}
            autoHighlight
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            id="serviceProvider"
            options={serviceProviders}
            getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue) {
                    return option.inputValue;
                }
                // Regular option
                return option.name;
            }}
            renderOption={(props, option) => <li {...props}> <div className={classes.options}>{option.name}</div></li>}
            freeSolo
            renderInput={(params) => (
                    <TextField
                        value={serviceProvider}
                        variant='outlined'
                        label={label}
                        InputLabelProps={{ className: classes.label }}
                        {...params}
                        inputProps={{
                            ...params.inputProps,
                            className: classes.input,
                            notchedOutline: classes.notchedOutline,
                        }}
                    />
            )}
            className={classes.input}
        />
    </>

}